import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { EventService } from "../event.service";
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";

// import Swal from "sweetalert2";
@Component({
  selector: 'app-add-event',
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.css']
})
export class AddEventComponent implements OnInit {

  planForm: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  selectedFile: File;
  uploadCourseImage: any;
  bannerImg="";
  timeZoneList = [
    "America/New_York",
    "America/Los_Angeles",
    "America/Phoenix",
    "America/Chicago",
    "America/Denver",
    "America/Anchorage",
    "Pacific/Honolulu",
  ];
  temp: any;

  desciptionName: string;
  planRequest = {
    title: null,
    date: null,
    time: null,
    eventEpoch:null,
    link: [],
    description:null,
    image:null,
    courseId:null
  }
  isUploading:boolean = false;
  courseList:[];
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private EventService: EventService
  ) { }

  ngOnInit() {
    this.initialiseForms();
    this.getCoureList();
  }

  AddFeature() {

    this.featureList.push(this.planForm.value.desciptionName.trim())
    if (this.featureList.length > 0) {
      this.showDesciptionError = false;
      this.planForm.controls['desciptionName'].setValue(" ");
    }
  }


//   <mat-form-field class="mat-form w-100">
//   <mat-label>Search by Status</mat-label>
//   <mat-select [(value)]="searchUserStatus">
//     <mat-option value="all">All Users</mat-option>
//     <mat-option value="active">Active</mat-option>
//     <mat-option value="blocked">Blocked</mat-option>
//     <!-- <mat-option value="suspended">Inactive</mat-option> -->
//   </mat-select>
// </mat-form-field>

  initialiseForms() {
    this.planForm = this.fb.group({
      date: ["", [Validators.required]],
      time: ["", [Validators.required]],
      title: ["", [Validators.required]],
      link: ["", [Validators.required]],
      courseId: [""],
      description: [, [Validators.required]],
      image: [""],
    });
  }
  SelectDate:string;
  onStartTimeChange(event) {
   // let startDateString = value.year + "-" + value.month + "-" + value.day;
  

      let travelDay = this.planForm.value.date.getDate();
      if (travelDay < 10) travelDay = "0" + travelDay;
      let travelMonth = this.planForm.value.date.getMonth() + 1;
      if (travelMonth < 10) travelMonth = "0" + travelMonth;
      let travelYear = this.planForm.value.date.getFullYear();
      this.SelectDate =  travelYear+'-'+travelMonth+'-'+travelDay;
      let date = this.SelectDate +"T"+this.planForm.value.time;

      var unix_seconds = ((new Date(date)).getTime()) /1000;

      this.planRequest.eventEpoch = unix_seconds;
     
  }
  
  Addplan() {
    this.formSubmitted = true;
    if (this.planForm.valid) {
      let travelDay = this.planForm.value.date.getDate();
      if (travelDay < 10) travelDay = "0" + travelDay;
      let travelMonth = this.planForm.value.date.getMonth() + 1;
      if (travelMonth < 10) travelMonth = "0" + travelMonth;
      let travelYear = this.planForm.value.date.getFullYear();
      this.SelectDate =  travelYear+'-'+travelMonth+'-'+travelDay;
      let date = this.SelectDate +"T"+this.planForm.value.time;
  
      var unix_seconds = ((new Date(date)).getTime()) /1000;
      this.planRequest.eventEpoch = unix_seconds;
      this.planRequest.title = this.planForm.value.title;
      this.planRequest.date = this.SelectDate;

      this.planRequest.link = this.planForm.value.link;
      this.planRequest.time = this.planForm.value.time;
      this.planRequest.description = this.planForm.value.description;
     
      if(this.planForm.value.courseId){
        this.planRequest.courseId  = this.planForm.value.courseId;
      }else {
        delete this.planRequest['courseId']
      }
      if(this.planForm.value.image) {
        this.planRequest.image = this.planForm.value.image;
      }else {
        delete this.planRequest.image;
      }
     
      
      console.log('plan REquest',this.planRequest)
      this.spinner.show();
      this.EventService.saveEvent(this.planRequest).subscribe(data => {
        this.spinner.hide();
        if ((data["message"] = "Success")) {
          Swal.fire("Success", "Event Added successfully!", "success");

          this.router.navigate(["/main/event-management/view-event"]);
        } else {
          this.spinner.hide();
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      }, err => {
        this.spinner.hide();
      });
    }




  }
  getCoureList() {
    this.spinner.show();
    this.EventService.getCourseList().subscribe(res => {

      if ((res["message"] = "Success")) {
        this.courseList = res.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });
  }

  cancel() {
    this.router.navigate(["/main/event-management/view-event"]);
  }
  removeImage(){
    this.uploadCourseImage ="";
    this.planForm.controls['image'].setValue(this.uploadCourseImage);
   }
  imageChangedEvent: any = '';
  croppedImage: any = '';
  fileChangeEvent(event: any): void {
    this.spinner.show();
    let file, img;
    if ((file = event.target.files[0]) && (file.type === "image/png" || file.type === "image/jpeg")) {
        img = new Image();
        this.imageChangedEvent = event;
        debugger;
    }
     else {
         
      }
      this.spinner.hide();
  }

  b64toBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
}
showImageError:boolean = true;
ImageUpload:boolean = false;
onFileChanged(event) {
  this.selectedFile = event.target.files[0];
  this.uploadCourseImage = this.selectedFile.name;
  this.spinner.show();
  this.EventService.uploadImage(this.selectedFile).subscribe(data => {
    if (data["status"] === "Success") {
      Swal.fire("Success", "Image uploaded successfully!", "success");
      this.spinner.hide();
      this.uploadCourseImage = data.url;
      this.planForm.controls['image'].setValue(this.uploadCourseImage);
      this.showImageError = false;
      this.ImageUpload = true;
      
    } else {
      this.spinner.show();
      Swal.fire({
        type: "error",
        title: "Error",
        text: data.msg
      });
    }
  });
}

}


